export const ENRICHMENT_TABS = {
    csv: { id: "csv", title: "si.enrichment.tabs.csv.text" },
    crm: { id: "crm", title: "si.enrichment.tabs.crm.text" },
};
